import {createBrowserRouter, RouterProvider, Navigate} from 'react-router-dom'
import Home from './pages/home'
import UserConfigs from './pages/userConfigs'
import Login from './pages/login'
import AuthProvider from './contexts/auth'
import {CookiesService} from './services/Cookie.service'
import ValidateEmailPage from './pages/validateEmail'
import ValidateSubscriptionPage from './pages/validateSubscription'
import GeneratorWaitingPage from './pages/GeradorDocumentos/generator-waiting-page'
import DocumentGenerator from './pages/GeradorDocumentos/document-generator'
import ProjetosPage from './pages/GeradorDocumentos/projetos'
import FlowPage from './pages/FlowQuestion'
import ValidateInvitePage from './pages/validateInvite'
import ErrorPage from './pages/error'
import {Outlet} from 'react-router-dom'
import HistoryProvider from './contexts/history'
import RED from './pages/R.E.D'
import CaronaInteligente from './pages/CaronaInteligente'
import ResetPassword from './pages/login/components/Form/resetPassword'
import SuportForm from './pages/suport'
import UploadDocuments from './pages/uploadDocuments'
import PesquisaPrecos from './pages/PesquisaPrecos'
import ContratacaoDireta from './pages/ContratacaoDireta'
import RadarFornecedor from './pages/RadarFornecedor'

function validateToken() {
    const cookiesService = new CookiesService()
    const authData = cookiesService.getAuthData()
    const isAuthenticated = authData?.access_token
    return isAuthenticated
}

const PrivateRoutesLayout = () => {
    return (
        <HistoryProvider>
            <Outlet />
        </HistoryProvider>
    )
}

const PublicRoute = (path: string, element: JSX.Element) => {
    const isAuthenticated = validateToken() && path.includes('login')
    return isAuthenticated
        ? {path, element: <Navigate to={'/'} />}
        : {path, element}
}
const ErrorRoute = (path: string, element: JSX.Element) => {
    return {path, element}
}
const router = createBrowserRouter([
    PublicRoute('/login', <Login />),
    PublicRoute('/admin', <Login />),
    PublicRoute('/login/confirm_email/:token', <ValidateEmailPage />),
    PublicRoute('/login/reset_password', <ResetPassword />),
    PublicRoute('/v1/login/first_login/:token', <ResetPassword />),
    PublicRoute('/login/invite/accept/:token', <ValidateInvitePage />),
    PublicRoute('/subscriptions/handle', <ValidateSubscriptionPage />),

    {
        element: validateToken() ? (
            <PrivateRoutesLayout />
        ) : (
            <Navigate to="/login" />
        ),

        children: [
            {path: '/', element: <Home />},
            {path: '/gerador', element: <DocumentGenerator />},
            {path: '/espera', element: <GeneratorWaitingPage />},
            {path: '/projetos', element: <ProjetosPage />},
            {path: '/configuracoes', element: <UserConfigs />},
            {path: '/flowPage', element: <FlowPage />},
            {path: '/analisador', element: <RED />},
            {path: '/carona', element: <CaronaInteligente />},
            {path: '/suporte', element: <SuportForm />},
            {path: 'upload-documents', element: <UploadDocuments />},
            {path: '/pesquisa-precos', element: <PesquisaPrecos />},
            {path: '/contratacao-direta', element: <ContratacaoDireta />},
            {path: '/radar-fornecedor', element: <RadarFornecedor />},
        ],
    },

    ErrorRoute('*', <ErrorPage />),
])

export default function AppRoutes() {
    return (
        <AuthProvider>
            <RouterProvider router={router} />
        </AuthProvider>
    )
}
